module.exports = __webpack_public_path__ + "img/fr.25089ea.svg";